import { useState, useCallback, useMemo } from 'react';

export const useBusyState = () => {
  const [busyScopes, setBusyScopes] = useState({});

  const isBusy = useMemo(
    () => Object.keys(busyScopes).length > 0,
    [busyScopes]
  );

  const begin = useCallback((scope) => {
    setBusyScopes((prev) => ({ ...prev, [scope]: (prev[scope] || 0) + 1 }));
  }, []);

  const end = useCallback((scope) => {
    setBusyScopes((prev) => {
      const count = (prev[scope] || 0) - 1;
      const next = { ...prev };
      if (count <= 0) delete next[scope];
      else next[scope] = count;
      return next;
    });
  }, []);

  return {
    busyScopes,
    isBusy,
    begin,
    end
  };
};